import { render, staticRenderFns } from "./DosandDonts.vue?vue&type=template&id=061569ae&"
import script from "./DosandDonts.vue?vue&type=script&lang=js&"
export * from "./DosandDonts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports